import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FAQS } from '@/data/site';

export default function FAQ() {
  return (
    <section className="section-pad bg-ohana-surface" data-testid="faq-section">
      <div className="container-ohana grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="overline">Questions, Answered</p>
          <h2 className="h-display text-4xl md:text-5xl mt-3 leading-tight">
            Frequently asked.
          </h2>
          <p className="mt-5 text-ohana-text-muted leading-relaxed">
            Don't see your question? Email{' '}
            <a
              href="mailto:ohanas@ohanapropertyexperts.com"
              className="text-ohana-primary font-semibold underline decoration-ohana-accent decoration-2 underline-offset-4"
              data-testid="faq-email-link"
            >
              ohanas@ohanapropertyexperts.com
            </a>{' '}
            and we'll get back the same day.
          </p>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="space-y-3">
            {FAQS.map((f, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="rounded-2xl border border-ohana-border bg-white px-6 data-[state=open]:border-ohana-accent data-[state=open]:shadow-lg data-[state=open]:shadow-ohana-primary/5 transition-all"
              >
                <AccordionTrigger
                  className="text-left text-base md:text-lg font-semibold text-ohana-primary hover:no-underline py-5"
                  data-testid={`faq-trigger-${idx}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ohana-text-muted leading-relaxed text-sm md:text-base pb-6 pr-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
